import React, { useState } from "react";

import DepositComponent from "./Deposit";
import WithdrawComponent from "./Withdraw";
import HistoryComponent from "./History";

const Funds = ({ activeTb }) => {
  const [activeTab, setActiveTab] = useState(activeTb ? activeTb : "deposit");
  const getTitle = (tab) => {
    if (tab === "withdraw") {
      return "WITHDRAW METHODS";
    } else if (tab === "history") {
      return "HISTORY";
    } else {
      return "DEPOSIT METHODS";
    }
  };

  return (
    <div className="min-h-screen text-white">
      {/* Header */}
      <div className="p-4 border-b border-gray-700">
        <h1 className="text-xl font-bold text-center">{getTitle(activeTab)}</h1>
      </div>

      {/* Tabs */}
      <div className="flex border-b border-gray-700">
        <button
          className={`flex-1 py-4 text-center font-medium ${
            activeTab === "deposit"
              ? "bg-shadeGreen text-green"
              : "bg-transparent"
          }`}
          onClick={() => setActiveTab("deposit")}
        >
          DEPOSIT
        </button>
        <button
          className={`flex-1 py-4 text-center font-medium ${
            activeTab === "withdraw"
              ? "bg-shadeGreen text-green"
              : "bg-transparent"
          }`}
          onClick={() => setActiveTab("withdraw")}
        >
          WITHDRAW
        </button>
        <button
          className={`flex-1 py-4 text-center font-medium ${
            activeTab === "history"
              ? "bg-shadeGreen text-green"
              : "bg-transparent"
          }`}
          onClick={() => setActiveTab("history")}
        >
          HISTORY
        </button>
      </div>

      {/* Tab Content */}
      {activeTab === "deposit" && <DepositComponent />}
      {activeTab === "withdraw" && <WithdrawComponent />}
      {activeTab === "history" && (
        // <div className="p-6">
        //   <div className="bg-[#041016] rounded-lg p-4 text-center">
        <HistoryComponent />
        //   </div>
        // </div>
      )}
    </div>
  );
};
export default Funds;
